module.exports = __webpack_public_path__ + "img/vertical-shot-educational-supplements-child-s-education-204803817.d5bc86c2.jpg";